import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { Router, RouterModule } from '@angular/router';
import { Coupon } from '../../models/coupon';
import { CouponService } from '../../services/coupon.service';
import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';


@Component({
  selector: 'app-coupons',
  imports: [
    CommonModule,
    DatePipe,
    FormsModule,
    TableModule,
    RouterModule,
    AdminPageHeaderComponent,
  ],
  templateUrl: './coupons.component.html',
  styleUrl: './coupons.component.scss'
})
export class CouponsComponent implements OnInit {
  title = 'Cupons';
  coupons: Coupon[] = [];
  isLoading = false;
  nameFilter = '';
  activeFilter = '';
  accountIdFilter: number | null = null;
  trustedOnlyFilter = false;
  totalItems = 0;
  page = 1;
  rowsPerPage = 20;
  feedbackError = '';
  selectedCouponIds = new Set<number>();

  constructor(private couponService: CouponService, private router: Router) {}

  ngOnInit(): void {
    this.fetchCoupons();
  }

  fetchCoupons(): void {
    this.isLoading = true;
    this.feedbackError = '';
    this.couponService.listCoupons({
      name: this.nameFilter.trim(),
      is_active: this.activeFilter,
      account_id: this.accountIdFilter ?? undefined,
      trusted_only: this.trustedOnlyFilter ? 'true' : undefined,
      page: this.page,
    }).subscribe({
      next: (response) => {
        this.coupons = response.results || [];
        this.totalItems = response.count || 0;
      },
      error: () => {
        this.coupons = [];
        this.totalItems = 0;
        this.isLoading = false;
        this.feedbackError = 'Não foi possível carregar os cupons.';
      },
      complete: () => (this.isLoading = false),
    });
  }

  clearFilters(): void {
    this.nameFilter = '';
    this.activeFilter = '';
    this.accountIdFilter = null;
    this.trustedOnlyFilter = false;
    this.page = 1;
    this.fetchCoupons();
  }

  toggleCouponSelection(coupon: Coupon, selected: boolean): void {
    const id = coupon.id;
    if (!id) {
      return;
    }
    if (selected) {
      this.selectedCouponIds.add(id);
    } else {
      this.selectedCouponIds.delete(id);
    }
  }

  isCouponSelected(id?: number): boolean {
    return !!id && this.selectedCouponIds.has(id);
  }

  toggleCurrentPageSelection(selected: boolean): void {
    this.coupons.forEach((coupon) => {
      if (coupon.id) {
        this.toggleCouponSelection(coupon, selected);
      }
    });
  }

  get allCurrentPageSelected(): boolean {
    return this.coupons.length > 0 && this.coupons.every((coupon) => this.isCouponSelected(coupon.id));
  }

  clearSelection(): void {
    this.selectedCouponIds.clear();
  }

  onFilterChange(): void {
    this.page = 1;
    this.fetchCoupons();
  }

  onLazyLoad(event: { first?: number }): void {
    const page = Math.floor((event.first ?? 0) / this.rowsPerPage) + 1;
    if (page !== this.page) {
      this.page = page;
      this.fetchCoupons();
    }
  }

  createCoupon(): void {
    this.router.navigate(['/dashboard/cupons/novo']);
  }

  editCoupon(id?: number): void {
    if (id) {
      if (this.selectedCouponIds.size > 1 && this.selectedCouponIds.has(id)) {
        this.editSelectedCoupons();
        return;
      }
      this.router.navigate(['/dashboard/cupons', id, 'editar']);
    }
  }

  editSelectedCoupons(): void {
    if (this.selectedCouponIds.size < 2) {
      return;
    }
    this.router.navigate(['/dashboard/cupons/editar-multiplos'], {
      queryParams: { ids: Array.from(this.selectedCouponIds).join(',') },
    });
  }
}
